






















import Vue from 'vue'
import { BaseContentContainer } from '@/components'
import { ShippingStatus } from './components'
import { IShipping } from '@/models'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, ACTIONS_ORDER, ROUTES } from '@/enums'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'OrderDetails',

    components: { BaseContentContainer, ShippingStatus },

    props: {
        orderCode: String,
        shippingId: String,
    },

    data: () => ({
        shipping: undefined as undefined | IShipping,
    }),

    async created() {
        try {
            this.shipping = await this.fetchShipping(this.shippingId)
        } catch (error) {
            this.$router.replace({ name: ROUTES.START })
        }
    },

    methods: {
        ...mapActions({
            fetchShipping: ACTIONS_ORDER.FETCH_SHIPPING,
        }),
    },
})
